import {IModel, IPoint} from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";

export enum OffsetLineType {
	primary = 'primary',
	secondary = 'secondary',
	default = 'default',
}

export default class OffsetLine {
	private readonly startPoint: IPoint;
	private readonly endPoint: IPoint;
	private readonly label: string;
	private readonly unit: string;
	private offset: IPoint;
	private readonly type: OffsetLineType;

	constructor( startPoint: IPoint, endPoint: IPoint, label: string, offset: IPoint = [0, 0], type = OffsetLineType.default, unit = 'cm' ) {
		this.startPoint = startPoint;
		this.endPoint = endPoint;
		this.label = label;
		this.unit = unit;
		this.offset = offset;
		this.type = type;
	}

	getModel(): IModel {
		const model = {} as IModel;
		const subModel = {} as IModel;
		makerjs.model.addPath(model, new makerjs.paths.Line(this.startPoint, this.endPoint), 'line');
		const measure =	makerjs.measure.modelExtents(model);

		let captionStartPoint = this.startPoint;
		let captionEndPoint = this.endPoint;

		// If the line is too short, we move the caption next to the line.
		if(measure && (measure.height <= 60 && measure.width <= 60) && this.startPoint[0] > 0 && this.endPoint[0] > 0) {
			captionStartPoint = [this.startPoint[0] - 25, this.startPoint[1]];
			captionEndPoint = [this.endPoint[0] - 25, this.endPoint[1]];
		}

		makerjs.model.addCaption(subModel, this.label, captionStartPoint, captionEndPoint);
		makerjs.model.addModel(model, subModel, 'cap');

		// Used to set an active state for the dimension line caption
		if (this.type === 'primary') {
			subModel.layer = 'white';
		}

		makerjs.model.moveRelative(model, this.offset);

		return model;
	}
}
